/**
 * Format Array by Unique key
 * @param arr {array}
 *
 * @return {array}
 */
export const arrayUniqueFormatter = (arr) => {
  return arr.filter((item, index, self) => self.indexOf(item) === index);
};
